const sortAlpha = (items: any[] | undefined | null): any[] => {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) =>
    String(a ?? "").localeCompare(String(b ?? ""), undefined, {
      sensitivity: "base",
    })
  );
};

export default sortAlpha;

